import React, { useState, useEffect } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
import { useTranslation } from 'react-i18next';
export default function ModalCancelAdd(props) {
  const { t } = useTranslation();
  const [styleFadeIn, setFadeIn] = useState(true);
  const closeModaleCancel = React.useCallback(() => {
    setFadeIn(false);
    setTimeout(() => {
      props.close();
    }, 400);
  }, []);
  return (
    <StyleRoot>
      <div
        class="modal show modal-skin"
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        id="modalCancel"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form>
              <button
                onClick={closeModaleCancel}
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close src="img/close.svg" class="img-fluid" alt="" />{" "}
              </button>
              <div class="modal-body">
                <section>
                  <h5 className="modal-title">{t('common.cancel')}</h5>
                </section>
                <section>
                  <h5>{t('creche.cancel_confirm')}</h5>
                </section>
                <p className="bottom-space"></p>
                <section>
                  <div className="d-flex justify-content-center">
                    <button type="submit" className="btn-gradient btn-confirm">
                      <img
                        src="img/icon-check-white.svg"
                        className="img-fluid"
                        alt=""
                      />{" "}
                      {t('common.confirm')}
                    </button>
                  </div>
                </section>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
